import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';

const useStyles = makeStyles(theme => ({
  // theme: console.log(theme),
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 600,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginBottom: '0.5em',
      marginTop: 0,
    },
    '& p': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  cards: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '& > div': {
      boxSizing: 'border-box',
      width: '49%',
      marginBottom: '1%',
      padding: '1.5em 1em',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid rgba(0, 0, 0, 0.2)'
    },
  },
  nav: {
    textAlign: 'center',
    margin: '0.5em 0',
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function Cards(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(0);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const len = Math.ceil(exercise.length / 10);

  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const init = () => {
    startStats(type);
    finishExercise();
  }

  const cardStyles = { 
    width: '40%',
    float: 'left',
    margin: '1%',
    border: '1px dotted #000',
    padding: '3em 0.5em',
    textAlign: 'center',
    fontSize: 18,
  }

  const next = () => {
    if (no < len - 1) setNo(no + 1);
    action();
  }

  const prev = () => {
    if (no > 0) setNo(no - 1);
    action();
  }

  const print = () => {
    action();
    const text = exercise.filter((word, idx) => idx >= no * 10 && idx < (no + 1 ) * 10).map((t, idx) => {
      return {
        text: t,
        style: cardStyles
      }
    });
    var w = window.open();
    const div = document.createElement( 'div' );
    text.forEach(el => {
      const p = document.createElement( 'p' );
      Object.keys(el.style).forEach(key => {
        p.style[key] = el.style[key];
      });
      p.innerText = el.text;
      div.appendChild(p);
    });
    const html = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Copyright Instytut Colina Rose Sp. z o.o.</title></head><body style="padding: 2em 1em; font-size: 18px;">${div.innerHTML}</body></html>`;
    w.document.write(html);
    w.print();
    w.close();
  }

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Podręczne karty</h3>
        <div className={classes.cards}>
          {exercise.filter((word, idx) => idx >= no * 10 && idx < (no + 1 ) * 10).map((word, idx) => <Card key={idx}>{word}</Card>)}
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
          <span>{no + 1}/{len} </span>
          <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1}><NextIcon /></Button>
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="primary" onClick={print}>Drukuj</Button>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(Cards);